// extracted by mini-css-extract-plugin
module.exports = {"content":"_23aYX","heading":"_1jH_t","themePurpleDark":"_3m897","themeWhite":"_3lOLy","headingGroup":"NxRlF","copy":"_2Fbl-"};